import css from 'styled-jsx/css';
import { colorHighlight, serif } from 'styles/css-constants';

// this file should include any global AMP HTML styling
export default css.global`
  .Html p,
  .Html ol,
  .Html ul {
    margin: 0 0 1rem;
    font-family: ${serif};
    font-size: 18px;
    line-height: 1.55;
  }

  .Html a {
    border-bottom: 1px solid ${colorHighlight};
    color: #000;
    text-decoration: none;
  }

  .Html ol,
  .Html ul {
    padding: 0 0 0 1rem;
  }

  .Html li {
    margin-bottom: 0.25rem;
  }
`;
